import SubItems from '@/components/InspectionReport/Items/SubItems';

export default {
    name: 'Form',
    functional: true,
    render(createElement, { props }) {
        return createElement(SubItems, {
            props: {
                items: props.item.items,
                resource: props.resource,
            },
        });
    },
};
